<template>
  <main><TermsTextBlock /></main>
</template>

<script>
import { PageMixin } from '~/mixins/PageMixin'
import { Head } from '~/mixins/Head'
import TermsTextBlock from '~/components/TermsTextBlock'

export default {
  computed: {
    metaObj() {
      return this.messages.terms.meta
    }
  },
  mixins: [PageMixin, Head],
  components: {
    TermsTextBlock
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// pages/terms.vue